export default function UserName({ userData, languageCode, userLoggedIn }) {
  if (!userLoggedIn) return null;
  return (
    <div className="hidden-content appear-quick">
      <h2 className="text-2xl mt-2">
        {userData != null &&
          languageCode != null &&
          userData.firstName != null && (
            <span className="hidden-content appear">
              {languageCode === "hu"
                ? `${userData?.lastName || ""} ${userData?.firstName || ""}`
                : `${userData?.firstName || ""} ${userData?.lastName || ""}`}
            </span>
          )}
      </h2>
    </div>
  );
}
